import { useRef, useState } from 'react';
import { createNotification } from "./helpers/createNotification";
export function useDataGridNotification() {
    var _a = useState(null), notificationContent = _a[0], setNotificationContent = _a[1];
    var _b = useState(true), canClose = _b[0], setCanClose = _b[1];
    var didCloseHandlerListRef = useRef([]);
    var dismissNotification = function () {
        setNotificationContent(null);
        var didCloseHandlers = didCloseHandlerListRef.current;
        didCloseHandlerListRef.current = [];
        didCloseHandlers.forEach(function (cb) { return cb(); });
    };
    return {
        notificationContent: notificationContent,
        showNotification: function (config) {
            setNotificationContent(createNotification(config));
            if (config.onDidClose) {
                didCloseHandlerListRef.current.push(config.onDidClose);
            }
            if (typeof config.canClose === 'boolean') {
                setCanClose(config.canClose);
            }
        },
        canCloseNotification: canClose,
        dismissNotification: dismissNotification
    };
}
//# sourceMappingURL=hooks.js.map